import { Injectable, Inject } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { SettingsModel } from '../models/settings.model';
import { LoiHttpClient } from 'loi-lti-common';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public static APP_LANG = 'nl-NL';
  private settings: SettingsModel;
  private settingsSubject: Subject<SettingsModel> = new Subject();
  private loading: boolean;

  constructor(private loiHttpClient: LoiHttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getSettings(): Observable<SettingsModel> {
    if (this.settings == null) {
      this.loading = true;
      this.loiHttpClient.get<SettingsModel>(`${this.baseUrl}api/Settings/GetSettings`).subscribe(result => {
        this.settings = result;
        this.loading = false;
        this.settingsSubject.next(this.settings);
      });
    }
    return this.loading ? this.settingsSubject : of(this.settings);
  }

  getSettingsPromise(): Promise<any> {
    const promise = this.loiHttpClient.get<SettingsModel>(`${this.baseUrl}api/Settings/GetSettings`).toPromise().then(result => {
      this.settings = result;
      return this.settings;
    });
    return promise;
  }

  getGoogleTagManagerId(): string {
    return this.settings ? this.settings.GoogleTagManagerId : '';
  }

  getBannersBaseUrl(): string {
    return this.settings ? this.settings.BannersBaseUrl : '';
  }

  getFaqUrl(): string {
    return this.settings ? this.settings.FaqUrl : '';
  }

  getConsumerIsNewCampusPortal(): boolean {
    return this.settings ? this.settings.ConsumerIsNewCampusPortal : false;
  }

  getDisableModuleActivation(): boolean{
    return this.settings ? this.settings.DisableModuleActivation : false;
  }
}
